// export const baseURL = 'http://localhost:8080/api/v1';
export const baseURL = 'https://api.schedulesmanager.com/api/v1';